import React, { useState } from 'react';
import { Box, Text, Table, Thead, Tbody, Tr, Th, Td, Button } from '@chakra-ui/react';
import { PageContainer } from '../../layouts/PageContainer';
import { PageHeader } from '../../layouts/PageHeader';
import { useNavigate } from 'react-router-dom';

const ExchangeApprovedRequest = () => {
    const [numRequests, setNumRequests] = useState(0);
    const navigate = useNavigate();

    // Dummy Data (Hard Coded)
    const tableData = [
        { id: '', age: '', year: '', height: '', weight: '', relation: '' },
        { id: '', age: '', year: '', height: '', weight: '', relation: '' },
        { id: '', age: '', year: '', height: '', weight: '', relation: '' },
    ];

    const goBack = () => {
        navigate('/view_all_requests_page');
    };

    return (
        <PageContainer>
            <PageHeader title="External Search" color="#1C4342"></PageHeader>
            <Box px={4} py={8}>
                <Text fontSize={"2.5rem"} color="#1C4342">
                    Approved Data
                </Text>

                <Table variant="simple">
                    <Thead>
                        <Tr bg="#1C4342">
                            <Th color="white" borderRight="1px solid white">Record ID</Th>
                            <Th color="white" borderRight="1px solid white">Age</Th>
                            <Th color="white" borderRight="1px solid white">Year</Th>
                            <Th color="white" borderRight="1px solid white">Height</Th>
                            <Th color="white" borderRight="1px solid white">Weight</Th>
                            <Th color="white" borderRight="1px solid white">Relation_1</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {tableData.map((data, index) => (
                            <Tr key={index}>
                                <Td borderRight="1px solid #CBD5E0">{data.id}</Td>
                                <Td borderRight="1px solid #CBD5E0">{data.age}</Td>
                                <Td borderRight="1px solid #CBD5E0">{data.year}</Td>
                                <Td borderRight="1px solid #CBD5E0">{data.height}</Td>
                                <Td borderRight="1px solid #CBD5E0">{data.weight}</Td>
                                <Td borderRight="1px solid #CBD5E0">{data.relation}</Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
                <Button colorScheme="teal" onClick={goBack} mb={4}>
                    Back
                </Button>
            </Box>
        </PageContainer>
    );
};

export default ExchangeApprovedRequest;
